/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var franceThalasso = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        var liToMove1 = $('#wprmenu_menu_ul .bandeau-droite .recherche-centre')
                          .eq(0)
                          .clone(),
            liToMove2 = $('#wprmenu_menu_ul .bandeau-droite .demande-brochure')
                          .eq(0)
                          .clone(),
            menuTopBtns = $(document.createElement('ul')).attr('id', 'menu_top_buttons');

        /* Set backgrounds */
        $('.to-bg').each(function(){
          var bg = $(this).attr('src');
          $(this).parent().css('background-image', 'url('+bg+')');
        });

        /* Wrap selects */
        $('select').each(function(){
          $(this).wrap('<div class="select-wrap"></div>');
        });
        $('.select-wrap').each(function(){
          var val = $(this).find('select option:selected').text();
          $(this).append('<div class="custom-select">'+val+'</div>');
        });
        $('select').change(function(){
          var val = $(this).find('option:selected').text();
          $(this).siblings('.custom-select').text(val);
        });

        /* Menu - mobile version */
        var mobileHeader = document.createElement('div'),
            mobileLogo = document.createElement('a'),
            mobileLang = document.createElement('ul');
        mobileHeader.id = 'mobile-header';
        mobileLogo.id = 'mobile-logo';
        mobileLogo.href = '/';
        mobileLang.id = 'mobile-lang';
        liToMove1.find('a').prepend('<i class="fa fa-search" aria-hidden="true"></i>');
        liToMove2.find('a').prepend('<i class="fa fa-file-text" aria-hidden="true"></i>');
        $('body > .container').append(mobileHeader);
        $('#menu-menu-institutionnel').clone().attr('id','menu-menu-institutionnel-mobile').appendTo('#wprmenu_menu');
        $('#menu-menu-institutionnel-mobile li').removeAttr('id');
        $('#wprmenu_menu').prepend(menuTopBtns);
        $('#menu_top_buttons').append(liToMove1).append(liToMove2);
        $('#mobile-header').append(mobileLogo).append(mobileLang);
        $('#menu-menu-institutionnel-mobile .menu-item-language').each(function(){
          $(this).appendTo('#mobile-lang');
        });

        /* Add class on scroll */
        $(window).scroll(function(){
          var scrollTop = $(this).scrollTop();
          
          if (scrollTop > 10) {
            $('body').addClass('scrolled');
          } else {
            $('body').removeClass('scrolled');
          }
        });

        /* Search toggle */
        $('#menu-maxi-menu .bop-nav-search .search-submit').hover(function(){
          $('#menu-maxi-menu .bop-nav-search').addClass('submit-hover');
        }, function(){
          $('#menu-maxi-menu .bop-nav-search').removeClass('submit-hover');
        });
        $('#menu-maxi-menu > li').hover(function(){
          $('#menu-maxi-menu > li > .sub-menu').stop(false,true);
          $(this).find('> .sub-menu').fadeIn(300);
        }, function(){
          $('#menu-maxi-menu > li > .sub-menu').stop(false,true);
          $(this).find('> .sub-menu').fadeOut(300);
        });
        $('#menu-maxi-menu .menu-item-type-search > .fa').click(function(){
          $('#menu-maxi-menu .menu-item-type-search .bop-nav-search').toggleClass('on');
        });

        /* Slider init */
        if ($('#slider').length) {
          $('#slider .slides').owlCarousel({
            navigation : true, // Show next and prev buttons
            slideSpeed : 300,
            paginationSpeed : 400,
            singleItem: true,
            autoPlay: true,
            afterUpdate: function(){
              $('#slider .owl-buttons').clone().appendTo('#slider .owl-pagination');
            }
          });

          var slider = $('#slider .slides').data('owlCarousel');

          $('#slider .owl-buttons').clone().appendTo('#slider .owl-pagination');
          $('body').on('click', '#slider .owl-pagination .owl-prev', function(){
            slider.prev();
          });
          $('body').on('click', '#slider .owl-pagination .owl-next', function(){
            slider.next();
          });
        }
        
        /* Scrollbar init */
        $(".scrollbar-outer").scrollbar();
        
        $('#scrollTop').on('click', function(e){
            e.preventDefault();
            scrollPos = 0;
            $('html, body').animate({
                scrollTop: scrollPos
            }, 500);
        });
        
        $('.wpcf7-checkbox .wpcf7-list-item .wpcf7-list-item-label').click(function(){
          $(this).siblings('input').trigger('click');
        });

        if (window.location.hash) {
          setTimeout(function() {
            window.scrollTo(0, 0);
          }, 1);
        }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'single_centre': {
      init: function() {
        // JavaScript to be fired on the centre page
        if ($('#download-block').length) {
          $('#download-link').click(function(e){
            e.preventDefault();
            $('#list-brochures').slideToggle();
          });
        }
        if ($('.video-block').length) {
            $('.fancybox-media').fancybox({
		openEffect  : 'none',
		closeEffect : 'none',
		helpers : {
			media : {}
		}
            });
        }
      }
    },
    'post_type_archive_centre': {
      init: function() {
            $('.fancybox-media').fancybox({
		openEffect  : 'none',
		closeEffect : 'none',
		helpers : {
			media : {}
		}
            });
      }
    },
    'page_template_template_base': {
      init: function() {
        var ancres = $('#ancres'),
            list = $('#ancres .ancres-list'),
            wrapper = $('#ancres .ancres-wrapper'),
            ancText = $('#ancres .ancres-wrapper .ancres-text'),
            refTop = ancText.offset().top,
            headerHeight,
            ancHeight;

        function changeFakeWrapper() {
          var wrapHeight = wrapper.height() + 25;
          $('#fake-wrapper').height(wrapHeight);
        }

        function openMenu(effect) {
          if (effect == 'transition') {
            list.slideDown(300);
          } else {
            list.slideDown(0);
          }
          ancres.addClass('on');
        }

        function closeMenu(effect) {
          if (effect == 'transition') {
            list.slideUp(300);
          } else {
            list.slideUp(0);
          }
          ancres.removeClass('on');
        }

        function checkHeaderHeight() {
          if ($(window).width() < 992) {
            headerHeight = $('#wprmenu_bar').height();
          } else {
            headerHeight = $('#menu-maxi-menu').height();
          }
        }

        function reInit() {
          ancres.removeClass('fixed');
          ancText.show();
          checkHeaderHeight();
          refTop = ancText.offset().top;
          ancHeight = ancText.height();
          checkPos(refTop);
        }

        function checkPos(top) {
          var winTop = $(window).scrollTop();

          if (winTop > top - headerHeight) {
            ancres.addClass('fixed');
            if ($(window).width() >= 768) {
              if (!ancText.hasClass('on')) {
                ancText.slideDown(300);
                ancText.addClass('on');
              }
            }
            if (ancres.hasClass('on')) {
              closeMenu();
            }
          } else {
            ancres.removeClass('fixed');
            changeFakeWrapper();
            if ($(window).width() >= 768) {
              if (!ancres.hasClass('on')) {
                openMenu();
              }
              if (ancText.hasClass('on')) {
                ancText.slideUp(0);
                ancText.removeClass('on');
              } else {
                ancText.hide();
              }
            } else {
              if (ancres.hasClass('on')) {
                closeMenu();
              }
            }
          }
        }

        reInit();
        changeFakeWrapper();

        $('#ancres ul li a').click(function(e){
          var href = $(this).attr('href'),
              pos = $(href).offset().top;

          e.preventDefault();
          $('html, body').animate({ scrollTop: pos - headerHeight - ancHeight }, 500);
        });

        ancText.click(function(){
          if (ancres.hasClass('on')) {
            closeMenu('transition');
          } else {
            openMenu('transition');
          }
        });

        $(window).resize(function(){
          reInit();
        });

        $(window).scroll(function(){
          checkPos(refTop);
        });
      }
    },
    'contactez_nous' : {
        init: function() {
            if(window.location.hash == "#mdp") {
                $('#nature').val("→ Mot de passe oublié");
                $('.custom-select').html("→ Mot de passe oublié");
            }
        }
    },
    'post_type_archive': {
      init: function() {
        if ($('#Filters').length) {
          var filters = $('#Filters');

          filters.find('.group-title').click(function(){
            var group = $(this).parent('.filter-group');
            if ($(window).width() < 992) {
              if (group.hasClass('open')) {
                group.removeClass('open').find('.checkboxes').slideUp();
              } else {
                filters.find('.filter-group.open').removeClass('open').find('.checkboxes').slideUp();
                group.addClass('open').find('.checkboxes').slideDown();
              }
            }
          });

          $('#Filters .checkboxes .scroll-to-results').click(function(e){
            var pos = $('#Container').offset().top;

            e.preventDefault();
            $('html, body').animate({ scrollTop: pos }, 500);
          });

          filters.find('.checkbox label').click(function(){
            $(this).siblings('input').trigger('click');
          });

          $(window).resize(function(){
            if ($(window).width() < 992) {
              filters.find('.filter-group.open').removeClass('open').find('.checkboxes').slideUp();
            }
          });
        }
        if($('#wpmem_login')) {
            $('#wpmem_login #log').attr( 'placeholder', 'Login' );
            $('#wpmem_login #pwd').attr( 'placeholder', 'Mot de passe' );
            $('#wpmem_login form').attr( 'action', '/doc-adherents/' );
            $('.button_div .buttons').addClass('classic-btn');
        }
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = franceThalasso;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  $(window).load(function(){
    if (window.location.hash) {
        var hash = window.location.hash;
        if ($('body').hasClass("post-type-archive-centre")) {
            var pos = $('#Container').offset().top - 46;
        }
        else {
            var pos = $(hash).offset().top;
            if ($('body').hasClass("page-template-template-base")) {
                pos = pos - 100;
            }
        }
        $('html, body').animate({ scrollTop: pos }, 500);
    }
  });

})(jQuery); // Fully reference jQuery after this point.
